import React from "react";
// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import PropTypes from "prop-types";

class YearFromControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      simpleSelect: "2018"
    };
  }
  handleSimple = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.handleDateChange(event.target.value);
  };
  render() {
    const { classes, data } = this.props;
    return (
      <FormControl fullWidth className={classes.selectFormControl}>
        <Select
          MenuProps={{
            className: classes.selectMenu
          }}
          classes={{
            select: classes.select
          }}
          value={this.state.simpleSelect}
          onChange={this.handleSimple}
          inputProps={{
            name: "simpleSelect",
            id: "simple-select"
          }}
        >
          {data.map((year, key) => {
            return (
              <MenuItem
                key={key}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected
                }}
                value={year}
              >
                {year}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  }
}

YearFromControl.propTypes = {
  data: PropTypes.array.isRequired
};
export default withStyles(styles)(YearFromControl);



// WEBPACK FOOTER //
// ./src/views/Dashboard/YearFormControl.jsx